import React, { useEffect, useState } from 'react'
import MainDatatable from '../../components/common/MainDatatable';
import logo_icon from '../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { EditSvg } from '../../assets/svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as FlightImageActions from '../../redux/actions/flightImageAction';

const DisplayFlightImage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { flightImageData } = useSelector(state => state?.flightImageReducer);

    //* DataTable Columns
    const columns = [
        { name: 'S.No.', selector: row => flightImageData.indexOf(row) + 1, style: { backGroundColor: "#000", paddingLeft: "20px" } },
        { name: 'Airline Name', selector: row => row?.airlineName },
        { name: 'Airline Code', selector: row => row?.airlineCode },
        { name: 'Airline Image', cell: row => <img src={row?.airlineImage ? row?.airlineImage : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() => navigate('/edit-flight-images', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
            </div >,
            width: "180px"
        },
    ];

    useEffect(() => {
        //! Dispatching API for Get Flight
        dispatch(FlightImageActions.getFlightImages());
    }, [])

    return (
        <>
            <MainDatatable data={flightImageData} columns={columns} title={'Flight Airline'} url={'/add-flight-images'} />
        </>
    )
}

export default DisplayFlightImage;